var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKycRejected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 68,
    viewBox: "0 0 95 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.562 30.4166V58.537C86.562 62.486 83.378 65.693 79.457 65.693H9.1058C5.1844 65.693 2 62.486 2 58.537V15.2428C2 11.2934 5.1844 8.0864 9.1058 8.0864H64.7142",
    stroke: "#721C24",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.213 19.3359L75.664 6.7875C74.614 8.2547 74 10.0547 74 12C74 16.9688 78.031 21 83 21C84.945 21 86.745 20.3859 88.213 19.3359ZM90.336 17.2125C91.386 15.7453 92 13.9453 92 12C92 7.0312 87.969 3 83 3C81.055 3 79.255 3.6141 77.788 4.6641L90.336 17.2125ZM95 12C95 18.6281 89.628 24 83 24C76.372 24 71 18.6281 71 12C71 5.3719 76.372 0 83 0C89.628 0 95 5.3719 95 12Z",
    fill: "#721C24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9053 37.6025H75.034",
    stroke: "#721C24",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9053 30.1787H59.4953",
    stroke: "#721C24",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3628 30.1787H75.034",
    stroke: "#721C24",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9053 44.165H75.034",
    stroke: "#721C24",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9053 50.7573H75.034",
    stroke: "#721C24",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8162 34.0392C25.9102 34.0392 28.4183 31.5132 28.4183 28.3973C28.4183 25.2813 25.9102 22.7554 22.8162 22.7554C19.7223 22.7554 17.2141 25.2813 17.2141 28.3973C17.2141 31.5132 19.7223 34.0392 22.8162 34.0392Z",
    stroke: "#721C24",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6642 51.3211H12.9683V48.2626C12.9683 42.7692 17.391 38.3447 22.8162 38.3447C28.2709 38.3447 32.6642 42.7989 32.6642 48.2626V51.3211Z",
    stroke: "#721C24",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycRejected);
export default __webpack_public_path__ + "static/media/kyc-rejected.73d2dfba8c3454689bf40f716a51739c.svg";
export { ForwardRef as ReactComponent };